<app-navbar></app-navbar>

<div class="m-lg-5 m-md-3">
  <app-accordion [data]="accordionData"></app-accordion>
</div>